import { LogoMark } from '@/components/Logo';

/**
 * Shown while GET /me resolves.
 *
 * Deliberately minimal and instant. The alternative — rendering the shell and
 * then filling it in — makes the nav appear and then lose half its items,
 * which reads as a bug rather than as loading.
 *
 * The mark does not spin. It carries an upright V, and a rotating letter reads
 * as broken rather than busy; the motion is carried by the bar underneath,
 * which is what indeterminate progress is for.
 */
export function SplashScreen() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-page">
      <div className="flex flex-col items-center gap-5">
        <LogoMark className="h-14 w-14 text-logo motion-safe:animate-[voltra-breathe_2s_ease-in-out_infinite]" />

        <div className="h-1 w-24 overflow-hidden rounded-full bg-border">
          <div className="h-full w-1/3 rounded-full bg-logo motion-safe:animate-[voltra-sweep_1.2s_ease-in-out_infinite]" />
        </div>

        <span className="sr-only">Loading Voltra POS</span>
      </div>
    </div>
  );
}
